import { render, staticRenderFns } from "./TopicParse.vue?vue&type=template&id=7c983ad2&scoped=true&"
import script from "./TopicParse.vue?vue&type=script&lang=js&"
export * from "./TopicParse.vue?vue&type=script&lang=js&"
import style0 from "./TopicParse.vue?vue&type=style&index=0&id=7c983ad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c983ad2",
  null
  
)

export default component.exports